import React from "react"

import productHitPreviewAttributes, {
	maxProductHitPreviewAttributes,
} from "config/productHitPreviewAttributes"

import { AlgoliaProductHit } from "@secureo/common/typings/Algolia"

const getAttributes = (hit: AlgoliaProductHit) => {
	const attributes: {
		name: string
		value: string
	}[] = []

	let i = 0
	while (
		attributes.length < maxProductHitPreviewAttributes &&
		attributes.length < productHitPreviewAttributes.length &&
		i < productHitPreviewAttributes.length
	) {
		const {
			name,
			label: { de: label },
		} = productHitPreviewAttributes[i]

		const value = hit[name]

		if (value) {
			attributes.push({
				name: label,
				value: Array.isArray(value) ? value.join(", ") : value,
			})
		}

		i++
	}

	return attributes
}

const ListViewItemAttributes = ({ hit }: Props) => {
	const attributes = getAttributes(hit)

	if (attributes.length === 0) return null

	return (
		<ul style={{ paddingLeft: 20 }}>
			{attributes.map((attribute) => {
				const { name, value } = attribute

				return (
					<li key={name}>
						{name}: {value}
					</li>
				)
			})}
		</ul>
	)
}

interface Props {
	hit: AlgoliaProductHit
}

export default ListViewItemAttributes
